import React, { FC } from "react";
import { useHistory } from "react-router-dom";

import { correctUploadPath } from "core/utils/image-path-correction";
import { CartItem } from "store/slices/cart/cart.types";
import { CartControls } from "../common/CartControls";

import NoImg from "assets/img/noImage.png";
import Style from "./Style.module.scss";
import { RouteEnum } from "core/enum/route.enum";

interface IProps {
  items: CartItem[];
}
const CartItems: FC<IProps> = ({ items }) => {
  const history = useHistory();

  const goToDetails = (id: number, product: any) => {
    // history.push({
    //   pathname: `/store/product/${id}`,
    //   state: { product },
    // });
    history.push({
      pathname: RouteEnum.ProductDetails.replace(
        ":type(product|service)",
        "product",
      ).replace(":id", String(id)),
      state: { product },
    });
  };

  return (
    <>
      {items.map((item) => {
        const imageSrc =
          item.product.files && item.product.files[0]
            ? `${process.env.REACT_APP_UPLOAD_SERVER_PATH}/${correctUploadPath(
                item.product.files[0],
              )}`
            : NoImg;

        return (
          <div
            key={item.product.id}
            className={Style.cartItem}
            onClick={() => goToDetails(item.product.id, item.product)}
          >
            <div className={Style.imageWrapper}>
              <img src={imageSrc} alt={item.product.title} />
            </div>

            <div className={Style.details}>
              <h3>{item.product.title}</h3>
              <p> {item.storeProductTitle}</p>
              <p>قیمت: {item.product.price.toLocaleString("fa-IR")} ریال</p>

              <div
                className={Style.quantityControls}
                onClick={(e) => e.stopPropagation()}
              >
                <CartControls product={item.product} />
              </div>
            </div>
          </div>
        );
      })}
    </>
  );
};

export { CartItems };
